import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  value: {},
  loading: false,
}

export const DashboardListSlice = createSlice({
  name: 'DashboardList',
  initialState,
  reducers: {
    Dashboard_List_request: (state, action) => {
      state.value = {};
      state.loading = true;
    },
    Dashboard_List_success: (state, action) => {

      state.value = action.payload;
      state.loading = false;
      state.error = {};

    },
    Dashboard_List_failure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.value = {};
    },
    Clear_Dashboard_List_Check: (state, action) => {
      state.value = {}
      state.error = {};
      state.loading = false;
    },
  }
})

// Action creators are generated for each case reducer function
export const {Dashboard_List_request, Dashboard_List_success, Dashboard_List_failure, Clear_Dashboard_List_Check } = DashboardListSlice.actions

export default DashboardListSlice.reducer